import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import SearchSelect from '../../../../moreCore/UI/SearchSelect/SearchSelect';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import template from './SelectRoomDialog.html?raw';
// NOTE (JS2TS): dropped dead dojo/dijit deps (connect, array, Color, keys, dijit
// _WidgetBase/_TemplatedMixin/_WidgetsInTemplateMixin, registry, dom-style, mouse). DOM-heavy → dom-construct aliased.

const domConstruct: any = domConstructTyped;

class SelectRoomDialog extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    returnCompleteEntities = false;
    dlg: any = null;

    callback: any = function () { };

    selection: any = {
        building: null,
        buildingpart: null,
        level: null,
        room: null,
        targettype: null,
        _label: null
    };

    _presetData: any = null;

    _buildings: any = [];
    _buildingParts: any = [];
    _rooms: any = [];
    _levels: any = [];

    layersNeeded = 4; // 3 = Gebäude + Teil + Level + Raum

    extendedData: any = ""; // zusätzliche Requestparameter...

    _onClick_Close(): void {
        this.close(0);
    }
    _onClick_Button_Cancel(evt?: any): void {
        this.close(0);
    }
    _onClick_Button_OK(evt?: any): void {

        var bSuccess = this.validate();

        if (bSuccess != true) {
            //this.close(0);
        } else {
            this.close(1);
        }
    }

    _setOKStyle(): void {

        //console.log("selectroomdialog _setOKStyle");

        if (this.validate() == true) {
            this.dlg.enableButton("ok");
        } else {
            this.dlg.enableButton("ok", false);
        }

    }

    preset(data: any): void {
        this.selection = data;
    }

    _setCallbackAttr(value: any): void {
        this.callback = value;
    }


    validate(): any {
        var bSuccess = true;

        //console.log("selectroom validation", this.layersNeeded, this.selection);

        if (this.layersNeeded >= 3 && (this.selection.room == null || this.selection.level == null || this.selection.level == "null")) {
            bSuccess = false;
        } else if (this.layersNeeded >= 1 && this.selection.level == null || this.selection.level == "null") {
            bSuccess = false;
        } else if (this.layersNeeded >= 0 && this.selection.building == null) {
            bSuccess = false;
        }

        return bSuccess;
    }

    _setNeededLayersAttr(value: any): void {
        this.layersNeeded = value;

        domClass.add(this.sectionBuilding, "w3-hide");
        //domClass.add(this.sectionBuildingpart, "w3-hide");
        domClass.add(this.sectionLevel, "w3-hide");
        domClass.add(this.sectionRoom, "w3-hide");

        if (true) {//value >= 0) {
            domClass.remove(this.sectionBuilding, "w3-hide");
        }

        //if (value >= 1) {
        //    domClass.remove(this.sectionBuildingpart, "w3-hide");
        //}

        if (value >= 2) {
            domClass.remove(this.sectionLevel, "w3-hide");
        }

        if (value >= 3) {
            domClass.remove(this.sectionRoom, "w3-hide");
        }

        switch (value) {
            case 0:
                this.selection.targettype = "building";
                break;

            case 1:
                this.selection.targettype = "buildingpart";
                break;

            case 2:
                this.selection.targettype = "level";
                break;

            case 3:
                this.selection.targettype = "room";
                break;
        }

    }

    setEmployee(employee: any): void {
        if (employee) {
            if (employee.ref_last_location && employee.ref_last_location.tmp_label) {
                domAttr.set(this.txtRegionFilter, "innerHTML", this.stringFormat(this.translations["SelectRoomDialog__RegionFilterNote"], employee.ref_last_location.tmp_label));
                domClass.remove(this.txtRegionFilterContainer, "w3-hide");
            }
        } else {
            domClass.add(this.txtRegionFilterContainer, "w3-hide");
        }
    }

    _renderBuildings(resetData?: any): void {
        domAttr.set(this.buildingNode, "innerHTML", "");
        //console.log("renderBuildings", resetData, this.selection, this._buildings);
        var option = domConstruct.create("option", {
            innerHTML: this.translations["General_DropdownBlank_Choose"],//"-- bitte wählen --",
            "disabled": "true",
            "selected": "true",
            value: null
        }, this.buildingNode);

        if (this.searchSelectBuilding) {
            this.searchSelectBuilding.destroy();
        }

        this.searchSelectBuilding = new SearchSelect();
        on(this.searchSelectBuilding, "change", lang.hitch(this, this._onChange_SearchSelectBuilding));
        this.searchSelectBuilding.labelAttribute = "tmp_label";
        this.searchSelectBuilding.selectableAttribute = "selectable";
        this.searchSelectBuilding.placeAt(this.sectionBuilding, 2);

        let buildingsWithLevels = [];
        let currentValue = null;

        for (let i = 0; i < this._buildings.length; i++) {
            let buildingEntity = this._buildings[i];
            let isActive = true;
            if (buildingEntity.aktiv === true || buildingEntity.aktiv === false) isActive = buildingEntity.aktiv;
            if (true) {

                let selectable = buildingEntity.EL_level.length > 0 || this.layersNeeded == 0;// entweder es gibt Stockwerke oder sie werden nicht benötigt

                if (!selectable) {
                    buildingEntity[this.searchSelectBuilding.labelAttribute] += " ** keine Ebene verfügbar **";
                }

                selectable = selectable && isActive;

                var option = domConstruct.create("option", {
                    innerHTML: buildingEntity.tmp_label,
                    value: buildingEntity.ID,
                    "disabled": !selectable,

                }, this.buildingNode);

                buildingsWithLevels.push(buildingEntity);

                if (this.selection.building == buildingEntity.ID) {
                    domAttr.set(option, "selected", true);
                    currentValue = buildingEntity;
                }

                buildingEntity["selectable"] = selectable;


            }
        }

        this.searchSelectBuilding.setData(buildingsWithLevels);
        this.searchSelectBuilding.setValue(currentValue, true);

        this._onChange_Building(resetData);
    }
    _onChange_SearchSelectBuilding(data: any): void {
        //console.debug("_onChange_SearchSelectBuilding", data);
        domAttr.set(this.buildingNode, "value", data);
        this._onChange_Building();
    }
    _onChange_SearchSelectLevel(data: any): void {
        //console.debug("_onChange_SearchSelectLevel", data);
        domAttr.set(this.levelNode, "value", data);
        this._onChange_Level();
    }
    _onChange_SearchSelectRoom(data: any): void {
        //console.debug("_onChange_SearchSelectRoom", data);
        domAttr.set(this.roomNode, "value", data);
        this._onChange_Room();
    }
    _onChange_Building(resetData?: any): void {
        //domAttr.set(this.buildingPartNode, "innerHTML", "");
        //domAttr.set(this.buildingPartNode, "disabled", "true");
        domAttr.set(this.levelNode, "innerHTML", "");
        domAttr.set(this.levelNode, "disabled", "true");
        domAttr.set(this.roomNode, "innerHTML", "");
        domAttr.set(this.roomNode, "disabled", "true");

        domClass.add(this.costCenterContainer, "w3-hide");


        if (resetData === false) {
        } else {
            this.selection.buildingpart = null;
            this.selection.level = null;
            this.selection.room = null;
        }
        this.selection.costCenterLabel = "";
        this.selection.building = domAttr.get(this.buildingNode, "value");
        this.selection._label = this.buildSelectionLabel();

        this._setOKStyle();


        //if (this.layersNeeded == 0) { // keine Unterebenen nötig, hier kann abgebrochen werden
        //    return;
        //}
        //console.log("change building", domAttr.get(this.buildingNode, "value"));

        for (var i = 0; i < this._buildings.length; i++) {
            var entity = this._buildings[i];

            if (entity.ID == this.selection.building) {
                //console.log("selected building", entity);
                if (this.layersNeeded > 0) {
                    this._levels = entity.EL_level;
                    this._renderLevels(resetData);
                    domAttr.remove(this.levelNode, "disabled");
                }

                if (entity.ref_building_cost_center && entity.ref_building_cost_center.dispname) {

                    let text = entity.ref_building_cost_center.dispname;

                    if (entity.ref_building_cost_center.verantwortlich) {
                        text += " - " + entity.ref_building_cost_center.verantwortlich;
                    }
                    domClass.remove(this.costCenterContainer, "w3-hide");
                    domAttr.set(this.txtCostCenter, "innerHTML", text);

                    this.selection.costCenterLabel = text;
                }

                break;
            }
        }
    }

    _renderBuildingParts(resetData?: any): void {
        domAttr.set(this.buildingPartNode, "innerHTML", "");

        if (bpEntities == null || typeof (bpEntities) == "undefined") {
            var bpEntities = this._buildingParts;
        }

        //console.log("render buildingparts", bpEntities);

        var option = domConstruct.create("option", {
            innerHTML: this.translations["General_DropdownBlank_Choose"],//"-- bitte wählen --",
            value: null,
            "disabled": "true",
            "selected": "true"
        }, this.buildingPartNode);

        for (var i = 0; i < bpEntities.length; i++) {
            var entity = bpEntities[i];

            var option = domConstruct.create("option", {
                innerHTML: entity.Name_number,
                value: entity.ID
            }, this.buildingPartNode);

            if (this.selection.buildingpart == entity.ID) {
                domAttr.set(option, "selected", true);
                //domAttr.set(dummyOption, "selected", false);
            }
        }

        this._onChange_Buildingpart(resetData);
    }


    _onChange_Buildingpart(resetData?: any): void {
        domAttr.set(this.roomNode, "innerHTML", "");
        domAttr.set(this.roomNode, "disabled", "true");


        if (resetData === false) {
        } else {
            this.selection.room = null;
        }

        var newBP = domAttr.get(this.buildingPartNode, "value");
        this.selection.buildingpart = newBP;

        this._setOKStyle();


        if (newBP == null || newBP == "" || typeof (newBP) == "undefined" || newBP == "null") {
            this.selection.buildingpart = null;
            this._rooms = null;
            this._renderRooms(null);
            return;
        }

        //console.info("changed buildingPart", this.selection);

        this.StandbyStart(this.sectionRoom);
        this.RequestManager.post(window.appRoot + "JDM/GetRoomListJSON",
            {
                "buildingpartId": this.selection.buildingpart,
                "levelNameId": this.selection.level
            },

            lang.hitch(this, function (response: any) {
                this.StandbyStop();

                //var rooms = JSON.parse(response);
                var rooms = response;
                this._rooms = rooms;

                //console.log( "rooms", rooms );
                this._renderRooms(rooms);
                domAttr.remove(this.roomNode, "disabled");
            }),
            lang.hitch(this, function (error: any) {
                this.StandbyStop();
                //console.log("login-error:", error);
                domAttr.set(this.messageNode, "innerHTML", error.Message);
            })
        );


    }

    _renderLevels(resetData?: any): void {
        domAttr.set(this.levelNode, "innerHTML", "");

        var levelEntities = null;

        //console.log("render levels", resetData, levelEntities);


        if (levelEntities == null || typeof (levelEntities) == "undefined") {
            var levelEntities = this._levels;
        }

        if (this.searchSelectLevel) {
            domClass.add(this.searchSelectLevel.domNode, "w3-hide");
            this.searchSelectLevel.destroy();
        }

        if (levelEntities != null) {

            this.searchSelectLevel = new SearchSelect();
            on(this.searchSelectLevel, "change", lang.hitch(this, this._onChange_SearchSelectLevel));
            this.searchSelectLevel.labelAttribute = "Name_number";
            this.searchSelectLevel.placeAt(this.sectionLevel);

            this.searchSelectLevel.setData(levelEntities);

            var option = domConstruct.create("option", {
                innerHTML: this.translations["General_DropdownBlank_Choose"],//"-- bitte wählen --",
                value: null,
                "disabled": "true",
                "selected": "true"
            }, this.levelNode);

            for (var i = 0; i < levelEntities.length; i++) {
                var entity = levelEntities[i];

                if (entity.ID) {
                    var option = domConstruct.create("option", {
                        innerHTML: entity.Name_number,
                        value: entity.ID
                    }, this.levelNode);

                    if (this.selection.level == entity.ID) {
                        domAttr.set(option, "selected", true);
                        this.searchSelectLevel.setValue(entity.ID, true);
                        //domAttr.set(dummyOption, "selected", false);
                    }
                }
            }
        }

        this._onChange_Level(resetData);
    }

    _onChange_Level(resetData?: any): void {
        domAttr.set(this.roomNode, "innerHTML", "");
        domAttr.set(this.roomNode, "disabled", "true");
        //domAttr.set(this.buildingPartNode, "innerHTML", "");
        //domAttr.set(this.buildingPartNode, "disabled", "true");


        if (resetData === false) {
        } else {
            this.selection.room = null;
            this.selection.buildingpart = null;
        }
        var newLevel = domAttr.get(this.levelNode, "value");
        this.selection.level = newLevel;
        this.selection._label = this.buildSelectionLabel();

        //console.info("changed level", this.selection);
        this._setOKStyle();


        if (newLevel == null || newLevel == "" || typeof (newLevel) == "undefined" || newLevel == "null") {
            this._rooms = null;
            //this._renderBuildingParts(resetData);

            return;
        }

        if (this.layersNeeded <= 2) { // 3 = Raum, 2 = Ebene, 1 = Gebäudeteil, 0 = Gebäude
            // Laden der Räume nicht nötig!
            return;
        }

        var requestData = {
            "buildingId": this.selection.building,
            //"levelNameId": this.selection.level, // bei JDM wählen wir wieder direkt die Ebene, nicht den Namen
            "levelId": this.selection.level,
            "extendedData": this.extendedData
        };

        this.StandbyStart(this.sectionRoom);
        this.RequestManager.callfunction("Webtool_Occurrence_API__GetRoomListJSON",
            requestData,

            lang.hitch(this, function (response: any) {
                this.StandbyStop();

                //var rooms = JSON.parse(response);
                var rooms = response;
                this._rooms = rooms;

                //console.log( "rooms", rooms );
                this._renderRooms(rooms);
                domAttr.remove(this.roomNode, "disabled");
            }),
            lang.hitch(this, function (error: any) {
                this.StandbyStop();
                //console.log("login-error:", error);
                domAttr.set(this.messageNode, "innerHTML", error.Message);
            })
        );


    }

    _onChange_Room(): void {
        this.selection.room = domAttr.get(this.roomNode, "value");
        //console.info("changed room", this.selection);
        this.selection._label = this.buildSelectionLabel();

        this._setOKStyle();
    }

    _renderRooms(roomEntities: any): void {
        domAttr.set(this.roomNode, "innerHTML", "");

        //console.log("render rooms", roomEntities);

        if (roomEntities == null || typeof (roomEntities) == "undefined") {
            return;
        }

        if (this.searchSelectRoom) {
            this.searchSelectRoom.destroy();
        }



        this.searchSelectRoom = new SearchSelect();
        on(this.searchSelectRoom, "change", lang.hitch(this, this._onChange_SearchSelectRoom));
        this.searchSelectRoom.labelAttribute = "tmp_label";
        this.searchSelectRoom.placeAt(this.sectionRoom);

        this.searchSelectRoom.setData(roomEntities);

        var option = domConstruct.create("option", {
            innerHTML: this.translations["General_DropdownBlank_Choose"],//"-- bitte wählen --",
            value: null,
            "disabled": "true",
            "selected": "true"
        }, this.roomNode);

        for (var i = 0; i < roomEntities.length; i++) {
            var entity = roomEntities[i];

            var option = domConstruct.create("option", {
                innerHTML: entity.tmp_label,
                value: entity.ID
            }, this.roomNode);

            if (this.selection.room == entity.ID) {
                domAttr.set(option, "selected", true);
                this.searchSelectRoom.setValue(entity.ID);
            }
        }
    }



    loadBuildings(resetData: any, callback?: any): void {

        this.StandbyStart(this.sectionBuilding);

        // progressbar über die Buildingnode legen
        this.startProgressbar(this.buildingNode);

        let exData = this.extendedData;
        if (typeof (this.extendedData) == "object" && this.extendedData != null) {

            if ((window as any).occurrenceSubstitution) {
                exData.ldapsubstitution = (window as any).occurrenceSubstitution;
            }

            exData = JSON.stringify(this.extendedData);
        }

        this.RequestManager.post(window.appRoot + "JDM/GetBuildingListJSON",
            {
                "jsonData": exData
            },
            lang.hitch(this, function (resetData: any, callback: any, response: any) {
                this.StandbyStop();
                this.stopProgressbar();

                //var buildings = JSON.parse(response);
                var buildings = response;
                this._buildings = buildings;

                //console.log( "buildings", buildings );
                this._renderBuildings(resetData);
                domAttr.remove(this.buildingNode, "disabled");

                if (callback) {
                    callback();
                }

            }, resetData, callback),
            lang.hitch(this, function (error: any) {
                this.StandbyStop();
                domAttr.set(this.messageNode, "innerHTML", error.Message);
            })
        );
    }


    _setHeaderAttr(value: any): void {
        this.dlg.set("header", value);
    }


    show(): void {
        this.dlg.show();

        this.loadBuildings(false);

        this.selection._label = this.buildSelectionLabel();
    }

    _onDlgClose(result: any): void {
        if (result >= 1) {
            this._onClick_Button_OK();
        } else {
            this._onClick_Button_Cancel();
        }
    }

    close(result?: any): void {

        if (typeof (result) == "undefined") {
            result = 0;
        }

        this.dlg.close(-1, true);

        if (this.returnCompleteEntities == true) {
            if (this.selection.building != null) {
                for (var i = 0; i < this._buildings.length; i++) {
                    if (this.selection.building == this._buildings[i].ID) {
                        this.selection.building = this._buildings[i];
                        break;
                    }
                }
            }

            if (this.selection.buildingpart != null) {
                for (var i = 0; i < this._buildingParts.length; i++) {
                    if (this.selection.buildingpart == this._buildingParts[i].ID) {
                        this.selection.buildingpart = this._buildingParts[i];
                        break;
                    }
                }
            }

            if (this.selection.level != null) {
                for (var i = 0; i < this._levels.length; i++) {
                    if (this.selection.level == this._levels[i].ID) {
                        this.selection.level = this._levels[i];
                        break;
                    }
                }
            }

            if (this.selection.room != null) {
                for (var i = 0; i < this._rooms.length; i++) {
                    if (this.selection.room == this._rooms[i].ID) {
                        this.selection.room = this._rooms[i];
                        break;
                    }
                }
            }

        }

        //  callback-function nahezu in echtzeit aufrufen. aber asynchron ...
        // weitere Parameter zurückgeben, zB. Textinput?
        //
        setTimeout(lang.partial(this.callback, result, this.selection), 1);

    }

    buildSelectionLabel(layersNeeded?: any): any {
        var label = "";

        //console.log("selectionlabel", this._buildings, this.selection);
        if (this.selection.room != null && (layersNeeded == 3 || typeof (layersNeeded) == "undefined")) {
            for (var i = 0; i < this._rooms.length; i++) {
                var room = this._rooms[i];

                if (room.ID == this.selection.room) {

                    //label = room.OKS_room;
                    label = room.dispname;
                    //label = room.tmp_label;
                    break;
                }
            }
        }

        else if (this.selection.level != null && (layersNeeded == 2 || typeof (layersNeeded) == "undefined")) {
            for (var i = 0; i < this._levels.length; i++) {
                var level = this._levels[i];

                if (level.ID == this.selection.level) {

                    //label = level.OKS_level;
                    //label = level.dispname;
                    label = level.tmp_label;


                    break;
                }
            }
        }

        else if (this.selection.building != null && (layersNeeded == 0 || !layersNeeded)) {
            for (var i = 0; i < this._buildings.length; i++) {
                var building = this._buildings[i];

                if (building.ID == this.selection.building) {

                    //label = building.Street + " (" + building.OKS_building + ")";
                    label = building.dispname;
                    //label = building.tmp_label;
                    break;
                }
            }
        }

        //console.debug("selectRoom Label", label);

        if (typeof (label) != "undefined") {
            return label;
        }


        return "";
    }

    startProgressbar(targetNode: any): void {
        //domConstruct.place(this.progressbarContainer, targetNode);
        //domClass.remove(this.progressbarContainer, "w3-hide");
    }

    stopProgressbar(): void {
        //domClass.add(this.progressbarContainer, "w3-hide");
        //domConstruct.place(this.progressbarContainer, this.domNode);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

        this._buildings = [];
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.dlg = new GenericDialog();
        this.dlg.keepOpen = true;
        this.dlg.addNodeToContent(this.domNode);
        this.dlg.set("callback", lang.hitch(this, this._onDlgClose));
        this.dlg.set("cancelBtn", true);
        this.dlg.set("OkBtn", true);
        this.dlg.enableContentOverflow(true);
        this.dlg.enableButton("ok", false);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);


    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }


}
SelectRoomDialog.prototype.declaredClass = 'WidgetCollection.Occurrence.SelectRoomDialog.SelectRoomDialog';

export default mdsWidget(SelectRoomDialog);
